// <s-header-scroll> — turns the header into a floating glass bar after the visitor scrolls past it.
// Sets data-scrolled on the closest <header>; the header keeps its height so the page never jumps.
class SHeaderScroll extends HTMLElement {
  #header = null;
  #frame = 0;
  #onScroll = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#update();
    });
  };

  connectedCallback() {
    this.#header = this.closest('header');
    if (!this.#header) return;
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onScroll);
    cancelAnimationFrame(this.#frame);
  }

  #update() {
    const header = this.#header;
    const scrolled = header.hasAttribute('data-scrolled');
    const bottom = header.offsetTop + header.offsetHeight;
    const y = window.scrollY;
    if (!scrolled && y > bottom + 40) {
      header.style.minHeight = `${header.offsetHeight}px`;
      header.setAttribute('data-scrolled', '');
    } else if (scrolled && y <= bottom) {
      header.removeAttribute('data-scrolled');
      header.style.minHeight = '';
    }
  }
}

if (!customElements.get('s-header-scroll')) customElements.define('s-header-scroll', SHeaderScroll);
